var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TheHeader',{attrs:{"isAuthenticated":_vm.isAuthenticated,"currentUser":_vm.currentUser}})}
var staticRenderFns = []

export { render, staticRenderFns }